import styled from 'styled-components';

const PlanDetailsWrapper = styled.div`
  margin-bottom: 16px;
  color: #262d3f;
`;

const PlanHeading = styled.div`
  font: 18px Avenir-Heavy;
  margin-bottom: 4px;
`;
const PlanTitle = styled.div`
  font: 20px Avenir-Heavy;
  margin-bottom: 4px;
`;
const PlanPremium = styled.div`
  font: 18px Avenir-Heavy;
`;
const PlanTerm = styled.span`
  font: 18px Avenir-Book;
  margin-left: 2px;
`;

export { PlanDetailsWrapper, PlanHeading, PlanTitle, PlanPremium, PlanTerm };
